export const TEST_ID = 'applicationsGridRow';
